export const DesignBespokeTourIcon = ({
  color = "#282828",
  size = 20,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_13135_10936)">
      <path
        d="M8.99541 13.772C8.06892 13.8535 7.14978 14.0038 6.24561 14.2217V15.2571C7.14782 15.0235 8.0674 14.8631 8.99541 14.7774V13.772Z"
        fill={color}
      />
      <path
        d="M10.999 13.772V14.7774C11.93 14.8627 12.8525 15.0232 13.7576 15.2571V14.2235C12.8506 14.0046 11.9285 13.8537 10.999 13.772Z"
        fill={color}
      />
      <path
        d="M16.4687 4.13794H19.0034V2.48877H1.00529V4.13794H3.52756L3.11482 15.3876C2.73196 15.5891 2.35987 15.8105 2.00009 16.0508V14.9714H1V18.4884H2.00009V17.2661C2.34325 17.0107 2.70071 16.7752 3.07073 16.5606L3.00018 18.5008H5.75174V9.089H14.2498V18.4884H16.9996L16.9291 16.5482C17.2991 16.7628 17.6566 16.9984 17.9997 17.2537V18.4761H18.9998V14.9714H17.9909V16.0508C17.631 15.8129 17.2589 15.5939 16.8762 15.3947L16.4687 4.13794ZM14.2498 7.43806H5.74998V4.13794H14.2498V7.43806Z"
        fill={color}
      />
      <path
        d="M6.25085 16.4989C6.25085 16.4989 6.2385 18.4726 6.25085 18.4867H13.7577V16.4989C12.7999 16.2502 11.313 15.9468 10.0078 15.9468C8.70256 15.9468 7.20861 16.2502 6.25085 16.4989Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_13135_10936">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
